<article>
    <div class="raffles">
        <p class="font-10 margin-top-3">{{home.textoRodape}}</p>
    </div>
    <div class="font-10 footer">
        <img src="./assets/botao_crescabrasil.png" alt="crescalogo" />
        <p class="margin-top-1">&copy;CRESÇA BRASIL 2023 - Todos os direitos reservados</p>
    </div>
</article>
